import wixWindow from 'wix-window';
import { templatesAction } from 'public/biLogger';
import storage from 'public/storage';

export function initExpressionsPage() {
    // @ts-ignore
	$w.onReady(async () => {
        const { items: templates } = await $w('#templatesDataset').getItems(0, 50);

        $w("#templatesRepeater").onItemReady(($item, itemData, index) => {
            const template = templates[index];
            
            const container = $item('#repItem');
            const editButton = $item('#editButton');
            const editButtonContainer = $item('#editButtonContainer');
            const viewButton = $item('#viewButton');
            const viewButtonContainer = $item('#viewButtonContainer');
            
            editButton.link = getEditLink(template);

            container.onMouseIn(() => {
                template.hoverStart = Date.now();
            });

            container.onMouseOut(async () => {
                const { window } = await wixWindow.getBoundingRect();
                const hoverMs = Date.now() - template.hoverStart;
                templatesAction({ action: 'hover', templateId: template.templateId, hoverMs, screenHeight: window.height, screenWidth: window.width });
            });

            container.onViewportEnter(async () => {
                if (!template.isViewed) {
                    const { window } = await wixWindow.getBoundingRect();
                    templatesAction({ action: 'impression', templateId: template.templateId, screenHeight: window.height, screenWidth: window.width });
                    template.isViewed = true;
                }
            });

            editButtonContainer.onClick(async () => {
                const { window } = await wixWindow.getBoundingRect();
                templatesAction({ action: 'edit', templateId: template.templateId, screenHeight: window.height, screenWidth: window.width });
            });

            viewButtonContainer.onClick(async () => {
                const { window } = await wixWindow.getBoundingRect();
                templatesAction({ action: 'view', templateId: template.templateId, screenHeight: window.height, screenWidth: window.width });
            });

            if (index === 0) {
                viewButton.collapse();
                if (wixWindow.formFactor !== 'Desktop') {
                    container.collapse();
                }
                if (wixWindow.formFactor !== 'Desktop') {
                    $w('#box383').collapse();
                }
            }
        })
    });
}

function getEditLink(template) {
    const editorSessionId = storage.getSessionId();
    return `http://manage.editorx.com/edit-template/from?originTemplateId=${template.metaSiteId}&editorSessionId=${editorSessionId}`;
}
